export default __webpack_public_path__ + "4a22bf95e24ced7929ab533a87ffba3f.webp";